$( document ).ready(function() {
  // if($('.c-product__slider').length > 0){
  //   $('.c-product__slider').slick({
  //     infinite: true,
  //     slidesToShow: 3,
  //     slidesToScroll: 1,
  //     dots: true,
  //     infinite: false,
  //     responsive: [
  //       {
  //         breakpoint: 749,
  //         settings: {
  //           slidesToShow: 1,
  //           variableWidth: true
  //         }
  //       }
  //     ]
  //   });
  // }

  const arr_collapse = document.querySelectorAll('.c-collapse__title');
  if(arr_collapse){
    for (let i = 0; i < arr_collapse.length; i++) {
        arr_collapse[i].addEventListener('click', function () {
            this.classList.toggle('is-active');
            let panel_collapse = this.nextElementSibling;
            if (panel_collapse.style.maxHeight) {
                panel_collapse.style.maxHeight = null;
            } else {
                panel_collapse.style.maxHeight = panel_collapse.scrollHeight + 'px';
            }
        });
    }
  }

  // if ($('.product-image-container').length > 0) {
  //   $('.product-image-container .zoom-wrapper').on('mouseenter', function() {
  //     $(this).zoom({
  //         on: 'click',
  //         magnify: 1.5,
  //         duration: 0
  //     });
  //   });
  //   $('.product-image-container .zoom-wrapper').on('mouseleave', function() {
  //     $(this).trigger('zoom.destroy');
  //   });
  // }
    
});